import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'core/ui/Button';
import ListingCard from 'core/components/ListingCard';
import ArrowRight from 'core/icons/ArrowRight';
import { ResponsiveCheck } from 'core/providers/Responsive';
import {
	FlexRow,
	ListingItemsContainer,
	SectionHeader,
	SectionTitle,
	SectionSubtitle,
} from 'core/styles';

class RecentListings extends Component {
	render() {
		const {
			title,
			subtitle,
			listings,
			favoriteIds,
			userId,
			mobile,
			large,
			showFavoriteLink,
			tracking,
		} = this.props;
		if (listings.length < 4) return null;

		return (
			<ResponsiveCheck>
				{({ isMobile }) => (<>
					<SectionHeader>
						<SectionSubtitle>{subtitle}</SectionSubtitle>
						<SectionTitle as="h4">{title}</SectionTitle>
					</SectionHeader>
					<ListingItemsContainer large={large}>
						{listings.map((listing, idx) => (
							<ListingCard
								key={listing.id}
								lazy
								mobile={isMobile}
								listing={listing}
								isLoggedIn={!!userId}
								favorited={favoriteIds.includes(listing.listingId)}
								// `listing_discovery` tracking params
								queryParams={{
									...tracking,
									cn: (idx + 1),
									sn: 'recent-listings',
								}}
							/>
						))}
					</ListingItemsContainer>
					{showFavoriteLink && (
						<FlexRow centered justifyCenter style={{ marginTop: 8 }}>
							<Button href={`/wishlist/${userId}/`} size="sm" themeType="stroke">
								<FlexRow centered>
									See all wishlisted
									<ArrowRight fill="currentColor" style={{ marginLeft: 4 }} />
								</FlexRow>
							</Button>
						</FlexRow>
					)}
				</>)
				}
			</ResponsiveCheck>
		);
	}
}

RecentListings.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	listings: PropTypes.array,
	favoriteIds: PropTypes.array,
	userId: PropTypes.number,
	mobile: PropTypes.bool,
	large: PropTypes.bool,
	showFavoriteLink: PropTypes.bool,
	tracking: PropTypes.object,
};

RecentListings.defaultProps = {
	title: "Recently viewed boxes",
	subtitle: "Just For You",
	listings: [],
	favoriteIds: [],
	tracking: {},
};

export default RecentListings;
